"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require("react-addons-css-transition-group");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _onEscape = require("utils/onEscape");

var _onEscape2 = _interopRequireDefault(_onEscape);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _PopupContainer = require("./PopupContainer");

var _PopupContainer2 = _interopRequireDefault(_PopupContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppPopupContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AppPopupContainer, _React$Component);

  function AppPopupContainer() {
    (0, _classCallCheck3.default)(this, AppPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(AppPopupContainer)).call(this));

    _this.closePopup = _this.closePopup.bind(_this);
    _this.onPreviousClick = _this.onPreviousClick.bind(_this);
    _this.onNextClick = _this.onNextClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AppPopupContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (__CLIENT__) {
        (0, _onEscape2.default)("popup", this.closePopup);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        (0, _onEscape2.default)("popup");
      }
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      var router = this.context.router;

      router.push(this.props.returnTo);
    }
  }, {
    key: "onPreviousClick",
    value: function onPreviousClick() {
      var router = this.context.router;

      router.push(this.props.previousTo());
    }
  }, {
    key: "onNextClick",
    value: function onNextClick() {
      var router = this.context.router;

      router.push(this.props.nextTo());
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require("./AppPopupContainer.scss");
      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: {
            leave: styles["AppPopupContainer--leave"],
            leaveActive: styles["AppPopupContainer--leave-active"],
            appear: styles["AppPopupContainer--appear"],
            appearActive: styles["AppPopupContainer--appear-active"],
            enter: styles["AppPopupContainer--appear"],
            enterActive: styles["AppPopupContainer--appear-active"]
          },
          key: "AppPopupContainer",
          component: "div",
          transitionEnter: true,
          transitionAppear: true,
          transitionLeave: true,
          transitionEnterTimeout: 150,
          transitionAppearTimeout: 150,
          transitionLeaveTimeout: 150
        },
        this.props.children && _react2.default.createElement(
          _PopupContainer2.default,
          {
            onClose: this.closePopup,
            previousTo: this.props.previousTo,
            nextTo: this.props.nextTo,
            onPreviousClick: this.onPreviousClick,
            onNextClick: this.onNextClick,
            showWhiteCloseBtn: this.props.showWhiteCloseBtn
          },
          _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
            isPopup: true,
            navigateTo: this.props.navigateTo,
            info: this.props.info,
            closePopup: this.closePopup
          })
        )
      );
    }
  }]);
  return AppPopupContainer;
}(_react2.default.Component), _class.propTypes = {
  children: _react.PropTypes.element,
  previousTo: _react.PropTypes.any,
  nextTo: _react.PropTypes.any
}, _class.contextTypes = {
  router: _react.PropTypes.object
}, _temp);
exports.default = AppPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppPopupContainer/AppPopupContainer.jsx
// module id = 2136
// module chunks = 0